import React, { Component } from "react";
import { Link } from "react-router-dom";

class ClaimCreateLocalTravel extends Component {
  render() {
    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 22 }}>
          <h4 style={{ margin: 0, fontWeight: 900, color: "#0F172A" }}>
            Create Local Travel Claim
          </h4>
          <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
            Claim expenses for official business travel within Malaysia.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 22 }}>
          <div>
            <div style={card}>
              <h5 style={sectionTitle}>Travel Information</h5>

              <div style={grid4}>
                {this.renderInput("Employee Name *", "Lee Min Hao")}
                {this.renderInput("Employee ID", "EMP-2024-0041", true)}
                {this.renderInput("Department *", "Operations")}
                {this.renderInput("Related Trip Ref", "TR-2024-0081")}
                {this.renderInput("Travel Purpose *", "Client site visit")}
                {this.renderInput("Travel Period *", "15 May 2024 - 17 May 2024")}
                {this.renderInput("Origin *", "Kuching")}
                {this.renderInput("Destination *", "Kuala Lumpur")}
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Travel Expense Items</h5>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#F8FAFC" }}>
                    {[
                      "#",
                      "Date",
                      "Category",
                      "Description",
                      "Receipt Ref",
                      "Amount (RM)",
                      "Receipt",
                      "Action",
                    ].map((h) => (
                      <th key={h} style={thStyle}>{h}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {[
                    ["1", "15 May 2024", "Flight", "Kuching to Kuala Lumpur flight ticket", "FLT-150524", "520.00", "Uploaded"],
                    ["2", "15 May 2024", "Transport", "Airport transfer and Grab rides", "GRB-150524", "85.00", "Uploaded"],
                    ["3", "16 May 2024", "Accommodation", "Hotel stay for 2 nights", "HTL-160524", "520.00", "Uploaded"],
                    ["4", "17 May 2024", "Meal", "Meal allowance during travel", "-", "125.00", "N/A"],
                    ["5", "Select date", "Select category", "Enter description", "Receipt ref", "0.00", "Upload"],
                  ].map((row) => (
                    <tr key={row[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                      <td style={tdStyle}>{row[0]}</td>
                      <td style={tdStyle}><input value={row[1]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[2]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[3]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[4]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[5]} readOnly style={{ ...tableInput, textAlign: "right" }} /></td>
                      <td style={tdStyle}>{this.renderReceiptStatus(row[6])}</td>
                      <td style={tdStyle}><button style={deleteButton}>🗑</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button style={{ ...secondaryButton, marginTop: 14 }}>+ Add Travel Expense</button>

              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 14, marginTop: 18 }}>
                <div style={{ fontWeight: 900 }}>TOTAL LOCAL TRAVEL CLAIM (RM)</div>
                <div style={totalBox}>1,250.00</div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Supporting Documents</h5>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
                <div style={uploadBox}>
                  <div style={{ fontSize: 30 }}>☁</div>
                  <div style={{ marginTop: 8, color: "#64748B" }}>
                    Drag and drop travel documents here, or <b>click to browse</b>
                  </div>
                  <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 6 }}>
                    PDF, JPG, PNG up to 10MB each
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: 900, marginBottom: 10 }}>Uploaded Documents (4)</div>
                  {[
                    "Flight_Ticket_KCH_KUL.pdf",
                    "Grab_Receipts_150524.pdf",
                    "Hotel_Invoice_160524.pdf",
                    "Trip_Approval_TR-2024-0081.pdf",
                  ].map((file) => (
                    <div key={file} style={fileRow}>
                      <span>{file}</span>
                      <span style={{ color: "#94A3B8" }}>×</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Declaration</h5>

              <label style={{ display: "flex", gap: 10, fontSize: 13, color: "#334155" }}>
                <input type="checkbox" defaultChecked />
                I confirm that the local travel expenses were incurred for approved official business travel.
              </label>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, marginTop: 18 }}>
                {this.renderInput("Signature of Employee", "Lee Min Hao")}
                {this.renderInput("Date", "20 May 2024")}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 18 }}>
              <Link to="/claim/create" style={secondaryLink}>Back</Link>
              <div style={{ display: "flex", gap: 10 }}>
                <button style={secondaryButton}>Save Draft</button>
                <button style={primaryButton}>Submit Claim ›</button>
              </div>
            </div>
          </div>

          <div>
            <div style={sideCard}>
              <h5 style={sectionTitle}>Claim Summary</h5>
              {this.renderSideRow("Related Trip", "TR-2024-0081")}
              {this.renderSideRow("Travel Route", "KCH → KUL")}
              {this.renderSideRow("Travel Duration", "3 days")}
              {this.renderSideRow("Total Amount", "RM 1,250.00")}
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Document Check</h5>
              <div style={checkRow}>✓ Trip approval attached</div>
              <div style={checkRow}>✓ Flight ticket attached</div>
              <div style={checkRow}>✓ Hotel invoice attached</div>
              <div style={checkRow}>✓ Transport receipts attached</div>
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Policy Notes</h5>
              <ul style={sideText}>
                <li>Claims must match approved travel dates.</li>
                <li>Receipts are required for transport and accommodation.</li>
                <li>Meal allowance should follow company policy rates.</li>
                <li>Unapproved travel claims may be rejected.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderReceiptStatus(status) {
    const map = {
      Uploaded: ["#ECFDF3", "#027A48"],
      "N/A": ["#F1F5F9", "#475569"],
      Upload: ["#FFF7E6", "#B76E00"],
    };

    const [bg, color] = map[status] || map.Upload;

    return (
      <span
        style={{
          background: bg,
          color,
          padding: "5px 10px",
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 900,
        }}
      >
        {status}
      </span>
    );
  }

  renderInput(label, value, disabled = false) {
    return (
      <div>
        <label style={labelStyle}>{label}</label>
        <input value={value} readOnly disabled={disabled} style={inputStyle} />
      </div>
    );
  }

  renderSideRow(label, value) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
        <span style={{ color: "#64748B", fontSize: 13 }}>{label}</span>
        <b style={{ color: "#0F172A", fontSize: 13 }}>{value}</b>
      </div>
    );
  }
}

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginBottom: 16,
};

const sideCard = {
  ...card,
  marginBottom: 16,
};

const sectionTitle = {
  margin: "0 0 16px",
  fontWeight: 900,
  color: "#0F172A",
};

const grid4 = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 800,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 38,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
  background: "#fff",
};

const thStyle = {
  padding: "10px 12px",
  textAlign: "left",
  fontWeight: 900,
  fontSize: 12,
  color: "#334155",
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: 8,
  fontSize: 13,
  color: "#334155",
};

const tableInput = {
  width: "100%",
  height: 34,
  border: "1px solid #E5E7EB",
  borderRadius: 6,
  padding: "0 10px",
  fontSize: 12,
  background: "#fff",
};

const totalBox = {
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 16px",
  minWidth: 170,
  textAlign: "right",
  fontWeight: 900,
  fontSize: 18,
};

const uploadBox = {
  border: "1px dashed #CBD5E1",
  borderRadius: 12,
  padding: 28,
  textAlign: "center",
  color: "#334155",
};

const fileRow = {
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "10px 12px",
  marginBottom: 8,
  display: "flex",
  justifyContent: "space-between",
  fontSize: 13,
};

const deleteButton = {
  border: "1px solid #FECACA",
  color: "#DC111C",
  background: "#fff",
  borderRadius: 6,
  width: 32,
  height: 32,
};

const primaryButton = {
  background: "#DC111C",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "11px 22px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 18px",
  fontWeight: 800,
};

const secondaryLink = {
  ...secondaryButton,
  textDecoration: "none",
};

const sideText = {
  color: "#64748B",
  fontSize: 13,
  lineHeight: "22px",
  paddingLeft: 18,
};

const checkRow = {
  color: "#027A48",
  fontSize: 13,
  fontWeight: 800,
  marginBottom: 10,
};

export default ClaimCreateLocalTravel;